import React from 'react'
import Collapsible from 'react-collapsible';
const Order = () => {
    return (
        <div className='container'>
            <td >



<h1 class="h1">Ordering of Sentences</h1>
<p>In this type of verbal ability questions, a sentence is broken down into six incomplete sentences, between the first and sixth sentence, there will be four incomplete sentences (A, B, C, and D or P, Q, R and S). You are required to arrange these sentences in a most appropriate sequence so that it forms a meaningful sentence.  </p>
<br />

<p class="pq">1) <br/>
Rishikesh is a beautiful hill station located beside the Himalayas</p>
<p>P: There are many ancient temples<br/>
Q: in the North of India<br/>
R: along the banks of the sacred river the Ganges<br/>
S: that flows through the city. </p>
<p class="pq">Furthermore, the city is also known for many famous yoga ashrams. </p>
<ol class="pointsu">
<li className='list'>SRPQ</li>
<li className='list'>QPRS</li>
<li className='list'>PQSR</li>
<li className='list'>RSPQ</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(1)"> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Rishikesh is a beautiful hill station located beside the Himalayas in the North of India. There are many ancient temples along the banks of the sacred river Ganges that flows through the city. Furthermore, the city is also known for many famous yoga ashrams. </p>
</div> </Collapsible>
<br />

<p class="pq">2) <br/>
A man who was living alone always had two plates on the dinner table. </p>
<p>P: One evening when he sat down to dine, the dog rushed into the room<br/>
Q: He used to give the dog a piece of meat from his plate <br/>
R: One plate was for him, and the other was for his dog<br/>
S: and dropped a piece of cheese into his plate and another piece of cheese into his master's plate. </p>
<p class="pq">Thus, the dog showed gratitude to his master. </p>
<ol class="pointsu">
<li className='list'>RPSQ</li>
<li className='list'>QPSR</li>
<li className='list'>RQPS</li>
<li className='list'>SQPR</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(2)"> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>One plate was for him and the other was for his dog. He used to give the dog a piece of meat from his plate. One evening when he sat down to dine, the dog rushed into the room and dropped a piece of cheese into his plate and another piece of cheese into his master's plate.</p>
</div> </Collapsible>
<br />

<p class="pq">3) <br/>
When a satellite is launched, the rocket goes up slowly through the air</p>
<p>P: as the atmosphere becomes thinner.<br/>
Q: The higher it moves, the less air it meets<br/>
R: as a result, friction is less. <br/>
S: As the rocket moves higher, its speed increases </p>
<p class="pq">Thus, the rocket does not heat up. </p>
<ol class="pointsu">
<li className='list'>SQPR</li>
<li className='list'>PRQS</li>
<li className='list'>SRPQ</li>
<li className='list'>RPQS</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(3)"> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>As the rocket moves higher, its speed increases. The higher it moves, the less air it meets as the atmosphere becomes thinner; as a result, the friction is less.</p>
</div> </Collapsible>
<br />

<p class="pq">4) <br/>
Obesity is one of the major reasons for hypertension.</p>
<p>A. WHO says, one in three adults suffers from hypertension<br/>
B. This health issue is about five times more common in obese people than those who are lean.<br/>
C. Understand that the intra-abdominal fat significantly affects the metabolism<br/>
D. as this fat may cause hypertension with increased blood lipids levels.</p>
<p class="pq">Thus, obese people must take appropriate measures to control or reduce their weight. </p>
<ol class="pointsu">
<li className='list'>ACDB</li>
<li className='list'>CDBA</li>
<li className='list'>ABCD</li>
<li className='list'>BACD</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(4)"> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>This health issue is about five times more common in obese people than those who are lean. WHO says, one in three adults suffers from hypertension. Understand that the intra-abdominal fat significantly affects the metabolism as this fat may cause hypertension with increased blood lipids levels.</p>
</div> </Collapsible>
<br />

<p class="pq">5) <br/>
Once the prince met a beautiful fisher girl </p>
<p>P: The prince got disappointed and returned home with a broken heart <br/>
Q: he went to meet the fisherman to express the desire to marry his daughter<br/>
R: he fell in love with that girl<br/>
S: The fisherman agreed for the marriage on one condition that the son of his daughter should be the heir to the throne.</p>
<p class="pq">The king asked the prince the reason for his sadness. </p>
<ol class="pointsu">
<li className='list'>QRSP</li>
<li className='list'>SPRQ</li>
<li className='list'>RQSP</li>
<li className='list'>PQRS</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(5)"> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>He fell in love with that girl he went to meet the fisherman to express the desire to marry his daughter. The fisherman agreed for the marriage on one condition that the son of his daughter should be the heir to the throne. The prince got disappointed and returned home with a broken heart. The king asked the prince the reason for his sadness.</p>
</div> </Collapsible>
<br/>






<p class="pq">6) <br/>
Green vegetables are good for health</p>
<p>P: If you want to live a healthy life,<br/>
Q: as these vegetable are high in minerals, vitamins, and other nutrients.<br/>
R: Prefer seasonal vegetables over preserved non-seasonal vegetables.<br/>
S: you must include green vegetables in your diet.</p>
<p class="pq">For example, spinach, fenugreek, mustard in the winter season. </p>
<ol class="pointsu">
<li className='list'>QPSR</li>
<li className='list'>SRQP</li>
<li className='list'>RSQP</li>
<li className='list'>SQRP</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(1)"> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Green vegetables are good for health as these vegetables are high in minerals, vitamins, and other nutrients. If you want to live a healthy life, you must include green vegetables in your diet. Prefer seasonal vegetables over preserved non-seasonal vegetables. For example, spinach, fenugreek, mustard in the winter season. </p>
</div> </Collapsible>
<br />

<p class="pq">7) <br/>
The leader of the villagers said that </p>
<p>P: In order to make them technically proficient in the job they take up. <br/>
Q: to provide training to people of the villages<br/>
R: in different jobs.<br/>
S: the government should make arrangements </p>
<p class="pq">Thus, they can be more financially stable. </p>
<ol class="pointsu">
<li className='list'>QPRS</li>
<li className='list'>SQRP</li>
<li className='list'>QRSP</li>
<li className='list'>RSQP</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(2)"> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>The leader of the villagers said that the government should make arrangements to provide training to the people of the villages in different jobs in order to make them technically proficient in the job they take up.</p>
</div> </Collapsible>
<br />

<p class="pq">8) <br/>
A city located amidst green hills should be full of greenery </p>
<p>A. But, instead of greenery, in Pune, you will see treeless roads, concrete cover and barren land.<br/> 
B. It shows that human and allied activities are denuding the city's green cover. <br/>
C. As per the Environment Status Report for 2012-13 the civic body's claim of taking eco-friendly measures to protect greenery is baseless. <br/>
D. The city is expanding, and building and wide roads are coming up.</p>
<p class="pq">This is not good for the greener cover of the city, the report said. </p>
<ol class="pointsu">
<li className='list'>BCAD</li>
<li className='list'>DCBA</li>
<li className='list'>ACDB</li>
<li className='list'>ADCB</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(3)"> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>A city located amidst green hills should be full of greenery. But, instead of greenery, in Pune, you will see treeless roads, concrete cover and barren land. As per the Environment Status Report for 2012-13 the civic body's claim of taking eco-friendly measures to protect greenery is baseless. The city is expanding, and buildings and wide roads are coming up. It shows that human and allied activities are denuding the city's green cover. This is not good for the greener cover of the city, the report said.</p>
</div> </Collapsible>
<br />

<p class="pq">9) <br/>
Five-star hotels and premium restaurants have decided to revise their menu card rates </p>
<p>A. From meats and seafood to curries, cheese, more than 50% of the cuisines at these restaurants are imported and do not have local substitutes. <br/>
B. Premium hotels and restaurants use imported food ingredients to delight the taste buds of their customers<br/> 
C. as due to the weak rupee the cost of the imported food ingredients and spices is increased <br/>
D. The rupee devaluation has affected the import.</p>
<p class="pq">As a result, they are revising the menu, without shifting the entire burden to the customers.  </p>
<ol class="pointsu">
<li className='list'>ABCD</li>
<li className='list'>CBAD</li>
<li className='list'>BCAD</li>
<li className='list'>DBAC</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(4)"> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>as due to the weak rupee the cost of the imported food ingredients and spices is increased. Premium hotels and restaurants use imported food ingredients to delight the taste buds of their customers. From meats and seafood to curries, cheese, more than 50% of the cuisines at these restaurants are imported and do not have local substitutes. The rupee devaluation has affected the import.</p>
</div> </Collapsible>
<br />

<p class="pq">10) <br/>
During monsoon, when humidity is high, we often do not drink the required amount of water which may cause dehydration. </p>
<p>A. Consuming an adequate amount of water and other liquids a day is essential to keep our organs working properly.<br/>
B. Adding some salt, spices, lemon, can make water more palatable.<br/>
C. The lime juice, which is high in Vitamin C, can improve our immunity in the monsoon season. <br/>
D. It is suggested people should drink different types of juices and drinks to keep themselves hydrated.</p>
<p class="pq">So, do not reduce the water intake in monsoons. </p>
<ol class="pointsu">
<li className='list'>CBAD</li>
<li className='list'>CABD</li>
<li className='list'>ADCB</li>
<li className='list'>ADBC</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(5)"> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Consuming an adequate amount of water and other liquids a day is essential to keep our organs working properly. It is suggested people should drink different types of juices and drinks to keep themselves hydrated.  Adding some salt, spices, lemon, can make water more palatable. The lime juice, which is high in Vitamin C, can improve our immunity in the monsoon season.</p>
</div> </Collapsible>
<br/>







<p class="pq">11) <br/>
Why the doctors are worried, shows what happens to our eyes in the bright sunlight without sunglasses. </p>
<p>A. the harmful infrared and UV lights are not blocked to the same extent<br/>
B. But when you walk into sunshine wearing sunglasses, your eyes feel comfortable, and your pupils remain wide open <br/>
C. The pupils of our eyes contract to protect the soft visual receptors inside. <br/>
D. For, in fact, many sunglasses screen only visible light. </p>
<p class="pq">These rays are not good for the eyes. </p>
<ol class="pointsu">
<li className='list'>CBDA</li> 
<li className='list'>CDBA</li>
<li className='list'>DCBA</li>
<li className='list'>CBAD</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(1)"> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Why the doctors are worried, shows what happens to our eyes in the bright sunlight without sunglasses. The pupils of our eyes contract to protect the soft visuals receptors inside. But when you walk into sunshine wearing sunglasses, your eyes feel comfortable and your pupils remain wide open. For, in fact, many sunglasses screen only visible light, the harmful infrared and UV lights are not blocked to the same extent. These rays are not good for the eyes.  </p>
</div> </Collapsible>
<br />

<p class="pq">12) <br/>
Today, newspapers are considered more balanced businesses, as they have a mix of revenues from advertisers and readers.</p>
<p>A. American newspapers are found highly unusual in their reliance on ads.  <br/> 
B. Not surprisingly Japanese newspapers are much more stable <br/>
C. Fully 87% of their revenues came from advertising in 2008 <br/>
D. In Japan, the proportion is around 35%. </p>
<p class="pq">So, newspapers should give emphasis on a right mix of advertisements and news. </p>
<ol class="pointsu">
<li className='list'>ACBD</li>
<li className='list'>ACDB</li>
<li className='list'>BDAC</li>
<li className='list'>BDCA</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(2)"> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Today, newspapers are considered more balanced businesses, as they have a mix of revenues from advertisers and readers. American newspapers are found highly unusual in their reliance on ads. Fully 87% of their revenues came from advertising in 2008. In Japan, the proportion is around 35%. Not surprisingly, Japanese newspapers are much more stable. So, newspapers should give emphasis on the right mix of advertisements and news. </p>
</div> </Collapsible>
<br />

<p class="pq">13) <br/>
The earthquake ripped through the oil pipeline in the city, killing at least 30 people. </p>
<p>A. Local leaders have blamed this damage on cartels. <br/>
B. The earthquake was the third in the three weeks <br/>
C. Police were deployed to stop villagers from stealing fuel from the pipeline <br/>
D. Once the cartels have siphoned off fuel, locals rushed to collect the oil and sell it to passing motorists.</p>
<p class="pq">But pipeline explosion is very common, and it has claimed around 2000 lives in the past three years.  </p>
<ol class="pointsu">
<li className='list'>DCBA</li>
<li className='list'>DBAC</li>
<li className='list'>CBAD</li>
<li className='list'>BCAD</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(3)"> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>The earthquake ripped through the oil pipeline in the city, killing at least 30 people.  The earthquake was the third in the three weeks. Police were deployed to stop villagers from stealing fuel from the pipeline. Local leaders have blamed this damage on cartels. Once the cartels have siphoned off fuel, locals rushed to collect the oil and sell it to passing motorists. But the pipeline explosion is very common, and it has claimed around 2000 lives in the past three years.  </p>
</div> </Collapsible>
<br />

<p class="pq">14) <br/>
More than 80% of the nation's primary schools are run by government bodies and most of them are underperforming. </p>
<p>A. On the literacy front, we are adding millions of virtual illiterates from these government schools. <br/>
B. The poor performance of government schools is the primary reason why the majority of students of these schools, even after completing five to six years of education, do not acquire the required literacy and numeric skills.  <br/>
C. This is one of the main reasons why 25 % of children in the primary school of the age group 6 to 10 years don't continue the study. <br/>
D. What is the impact of these underperforming primary schools on our students and education system?</p>
<p class="pq">As 39% of our population is illiterate, illiteracy will continue till next century. </p>
<ol class="pointsu">
<li className='list'>DCAB</li>
<li className='list'>ABCD</li>
<li className='list'>CBDA</li>
<li className='list'>CDAB</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(4)"> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>This is one of the main reasons why 25 % of children in the primary school of the age group 6 to 10 don't continue the study. The poor performance of government schools is the primary reason why the majority of students of these schools, even after completing five to six years of education, do not acquire the required literacy and numeric skills.  What is the impact of these underperforming primary schools on our students and education system?  On the literacy front, we are adding millions of virtual illiterates from these government schools. </p>
</div> </Collapsible>
<br />

<p class="pq">15) <br/>
The study of the effect of exercise on the immune system involves extensive research and analysis.   </p>
<p>A. It is found in studies that exercise helps improve the functions of the immune cells.  <br/>
B. For example, if a patient is suffering from a sore throat, the yoga pose "Sarvangasana" can reduce the frequency of the infection. <br/>  
C. This increases the immunity cells in those areas. <br/>
D. In yoga, regional immunity can be improved by improving the blood circulation of an area.</p>
<p class="pq">Immunity can also be improved by de-stressing the body and mind. </p>
<ol class="pointsu">
<li className='list'>ADCB</li> 
<li className='list'>DCBA</li>
<li className='list'>ABDC</li>
<li className='list'>CDBA</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(5)"> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>It is found in studies that exercise helps improve the functions of the immune cells. In yoga, regional immunity can be improved by improving the blood circulation of an area. This increases the immunity cells in those areas. For example, if a patient is suffering from a sore throat, the yoga pose "Sarvangasana" can reduce the frequency of the infection.  </p>
</div> </Collapsible>
<br/>







<p class="pq">16) <br/>
Frostbite damages the skin. It happens when the skin is exposed to extreme cold for too long. </p>
<p>A. In minor cases of frostbite that affect only the skin, permanent damage may not be caused.<br/>
B. It mostly affects the nose, ears, feet, and hands.<br/> 
C. But if deeper tissues are affected, one may feel pain every time the affected area gets cold.<br/>
D. Furthermore, if blood vessels are damaged, it may cause infection, gangrene, etc.</p>
<p class="pq">In critical cases, doctors may have to remove affected areas like fingers, toes, ears, etc. </p>
<ol class="pointsu">
<li className='list'>BADC</li>
<li className='list'>BACD</li>
<li className='list'>BCDA</li>
<li className='list'>DCBA</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(1)"> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p><strong>Frostbite damages the skin. It happens when the skin is exposed to extreme cold for too long</strong>. It mostly affects the nose, ears, feet, and hands. In minor cases of frostbite that affect only the skin, permanent damage may not be caused. But if deeper tissues are affected, one may feel pain every time the affected area gets cold. Furthermore, if blood vessels are damaged, it may cause infection, gangrene, etc. <strong>In critical cases, doctors may have to remove affected areas like fingers, toes, ears, etc</strong>.</p>
</div> </Collapsible>
<br />

<p class="pq">17) <br/>
Exercise is important if you want to lose weight and get in shape. </p>
<p>A. If you consume more calories than you need.<br/>
B. Experts also agree that to lose weight, you need to burn more calories than you consume.<br/>
C. But, according to experts, exercise alone can't help you lose weight.<br/>
D. Also, there is no single diet plan for everyone.</p>
<p class="pq">It will be stored as fat in your body. </p>
<ol class="pointsu">
<li className='list'>CDBA</li>
<li className='list'>CDAB</li>
<li className='list'>ABCD</li>
<li className='list'>DCAB</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(2)"> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Exercise is important if you want to lose weight and get in shape. But, according to experts, exercise alone can't help you lose weight. Also, there is no single diet plan for everyone. Experts also agree that to lose weight, you need to burn more calories than you consume. If you consume more calories than you need, it will be stored as fat in your body.</p>
</div> </Collapsible>
<br />

<p class="pq">18) <br/>
Smoking kills around five million people worldwide in a year.</p>
<p>A. According to studies, many cancers can be prevented by avoiding smoking and tobacco use.<br/>
B. Smoking also causes cancer.<br/>
C. The government should aware the people about the health risks of smoking<br/>
D. Experts say it is the second leading cause of death, after cancer.</p>
<p class="pq">and suggest natural ways to quit smoking. </p>
<ol class="pointsu">
<li className='list'>BADC</li>
<li className='list'>ACDB</li>
<li className='list'>DBAC</li>
<li className='list'>CABD</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(3)"> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Smoking kills around five million people worldwide in a year. Experts say it is the second leading cause of death, after cancer. Smoking also causes cancer. According to studies, many cancers can be prevented by avoiding smoking and tobacco use. The government should aware the people about the health risks of smoking and suggest natural ways to quit smoking.</p>
</div> </Collapsible>
<br />

<p class="pq">19) <br/>
Vitamin A is good for health. </p>
<p>A. It is also good for eyes as it is required to make a light-sensitive substance in the eyes.<br/>
B. It prevents skin from becoming dry.<br/>
C. People who are deficient in vitamin A may have problems seeing at night<br/>
D. and may have dry eyes.</p>
<p class="pq">So, eat fruits and vegetable that are high in vitamin A. </p>
<ol class="pointsu">
<li className='list'>DCBA</li>
<li className='list'>ABCD</li>
<li className='list'>CABD</li>
<li className='list'>BACD</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(4)"> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Vitamin A is good for health. It prevents skin from becoming dry. It is also good for eyes as it is required to make a light-sensitive substance in the eyes. People who are deficient in vitamin A may have problems seeing at night and may have dry eyes.</p>
</div> </Collapsible>
<br />

<p class="pq">20) <br/>
Cuts on the skin may cause infection if left untreated. </p>
<p>A. A large number of bacterial skin infections are resistant to antibiotics.<br/>
B. So, if there is any cut on the skin or an injury that breaks the skin,<br/>
C. The bacteria can enter the body through these cuts.<br/>
D. These infections may spread to other parts of the body from the affected area.</p>
<p class="pq">you should take good care of it to prevent an infection.   </p>
<ol class="pointsu">
<li className='list'>CADB</li>
<li className='list'>ACDB</li>
<li className='list'>CDBA</li>
<li className='list'>BCDA</li>
</ol>
<Collapsible trigger='show answer' triggerClassName="showanswer" onclick="showhide(5)"> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Cuts on the skin may cause infection if left untreated. The bacteria can enter the body through these cuts. A large number of bacterial skin infections are resistant to antibiotics. These infections may spread to other parts of the body from the affected area. So, if there is any cut on the skin or an injury that breaks the skin, you should take good care of it to prevent an infection. </p>
</div> </Collapsible>
<br/>


</td>
        </div>
    )
}

export default Order
